import * as React from 'react';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import ListStore from './store';
import Page from '../../components/page';
import Article1 from './components/article-1';
import Article2 from './components/article-2';
import Article3 from './components/article-3';
import Article4 from './components/article-4';
import Article5 from './components/article-5';
import Article6 from './components/article-6';
import Nav from './components/nav';
import styles from './index.less';
import Link from '@src/components/link';
import $$tracker from '@src/tracker';

const ListPage = observer(() => {
  // 初始化 Store
  const store = useStore(() => new ListStore());

  /**
   * 渲染选中的文章
   * @returns {JSX.Element|null}
   */
  const renderArticle = () => {
    switch (store.articleId) {
      case 11867:
        return <Article1 />;
      case 11866:
        return <Article2 />;
      case 11868:
        return <Article3 />;
      case 11869:
        return <Article4 />;
      case 11870:
        return <Article5 />;
      case 11871:
        return <Article6 />;
      default:
        return null;
    }
  };

  return (
    <Page className={styles.root}>
      <div className="xfe-root">
        <div className="xfe-layer-1" />
        <div className="xfe-layer-2" />
        {store.articleId && renderArticle()}

        <Nav store={store} />

        <div className="xfe-top-actions">
          <Link className="btn-official" href="https://jxsj.xoyo.com/index/index.html" target="_blank" rel="noopener noreferrer" onClick={()=>$$tracker.clickGoWebsite()}/>
          <Link className="btn-download" href="https://jxsj.xoyo.com/index/download.html" target="_blank" rel="noopener noreferrer" onClick={()=>$$tracker.clickDownload()}/>
        </div>
      </div>
    </Page>
  );
});

export default ListPage;
